// extracted by mini-css-extract-plugin
module.exports =  {"container":"_0bc5e8de02--container--d4ezv","container--pessimized":"_0bc5e8de02--container--pessimized--Kcd1B","placeholder":"_0bc5e8de02--placeholder--y_Vqq"};